import React from "react";

const QuizIcon = () => {
    return (
        <svg
            width={25}
            height={25}
            viewBox="0 0 52 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32.541 47.0657H18.3413C5.49056 47.0657 0 42.0459 0 30.297V17.3149C0 5.56598 5.49056 0.546204 18.3413 0.546204H23.0745C24.0449 0.546204 24.8495 1.28186 24.8495 2.16898C24.8495 3.05609 24.0449 3.79175 23.0745 3.79175H18.3413C7.43118 3.79175 3.54993 7.34021 3.54993 17.3149V30.297C3.54993 40.2717 7.43118 43.8201 18.3413 43.8201H32.541C43.4511 43.8201 47.3324 40.2717 47.3324 30.297V25.9696C47.3324 25.0825 48.137 24.3469 49.1073 24.3469C50.0777 24.3469 50.8823 25.0825 50.8823 25.9696V30.297C50.8823 42.0459 45.3918 47.0657 32.541 47.0657Z"
                fill="#00427F"
            />
            <path
                d="M17.1564 36.1176C15.7128 36.1176 14.3875 35.6416 13.4172 34.7761C12.2575 33.7159 11.7605 32.1797 12.0209 30.5569L13.0385 24.0442C13.2278 22.7892 14.1271 21.1665 15.0975 20.2793L33.7463 3.22932C38.4559 -1.07644 43.2364 -1.07644 47.946 3.22932C50.5256 5.58775 51.6853 7.98945 51.4486 10.3912C51.2356 12.3385 50.0996 14.2425 47.946 16.1899L29.2971 33.2399C28.3267 34.127 26.5518 34.9492 25.1791 35.1223L18.0557 36.0527C17.7481 36.1176 17.4404 36.1176 17.1564 36.1176ZM36.2549 5.52284L17.6061 22.5729C17.1564 22.984 16.6358 23.936 16.5411 24.4985L15.5234 31.0113C15.4288 31.6387 15.5708 32.158 15.9258 32.4826C16.2808 32.8071 16.8488 32.937 17.5351 32.8504L24.6585 31.92C25.2738 31.8335 26.3388 31.3575 26.7648 30.9464L45.4137 13.8963C46.952 12.4899 47.7567 11.235 47.875 10.0666C48.017 8.6602 47.2124 7.16725 45.4137 5.5012C41.6271 2.03929 39.0239 3.01295 36.2549 5.52284Z"
                fill="#00427F"
            />
            <path
                d="M44.0182 19.1103C43.8525 19.1103 43.6868 19.0886 43.5448 19.0453C37.3206 17.4442 32.3744 12.9221 30.6231 7.23156C30.3628 6.36608 30.9071 5.47897 31.8537 5.21932C32.8004 4.98132 33.7707 5.47897 34.031 6.34445C35.451 10.9531 39.4506 14.6098 44.4915 15.908C45.4381 16.146 45.9824 17.0547 45.7221 17.9202C45.5091 18.6559 44.7991 19.1103 44.0182 19.1103Z"
                fill="#00427F"
            />
        </svg>
    );
};

export default QuizIcon;
